import { useCallback } from 'react'
import { Vector2Like } from 'three'
import { uiToModel } from '~/components/DrawingCanvas/util/units'
import { getCounterClockwisePoints } from '~/components/DrawingCanvas/Walls/util'
import LayerKeys from '~/config/layerKeys'
import { DEFAULT_WALL_SIZES } from '~/config/wallSizes'
import { guid } from '~/lib/utils'
import { useAppDispatch } from '~/store/hooks'
import { addObject } from '~/store/objects'
import { DenormalizedWall } from '~/store/objects/types'

export function useMakeWall(layerKey: LayerKeys) {
  const dispatch = useAppDispatch()

  const { thickness, height } =
    layerKey in DEFAULT_WALL_SIZES
      ? DEFAULT_WALL_SIZES[layerKey as keyof typeof DEFAULT_WALL_SIZES]
      : DEFAULT_WALL_SIZES.EXTERIOR_WALLS

  return useCallback(
    (points: Vector2Like[]) => {
      const wallId = guid()
      const wallModel: DenormalizedWall = {
        id: wallId,
        layerKey: layerKey as 'EXTERIOR_WALLS' | 'INTERIOR_WALLS',
        segments: [],
        isEnclosed: true,
        roofSectionIds: [],
        position: { x: 0, y: 0, z: 0 },
      }

      const wallPoints = getCounterClockwisePoints(points)
      for (let i = 0; i < wallPoints.length - 1; i++) {
        const start = wallPoints[i]
        const end = wallPoints[i + 1]
        wallModel.segments.push({
          id: guid(),
          parentId: wallId,
          layerKey: layerKey as 'EXTERIOR_WALLS' | 'INTERIOR_WALLS',
          thickness,
          height,
          startPoint: { x: uiToModel(start.x), y: uiToModel(start.y), z: 0 },
          endPoint: { x: uiToModel(end.x), y: uiToModel(end.y), z: 0 },
          isFullHeight: false,
          materialIndex: 0,
        })
      }

      dispatch(addObject({ object: wallModel }))
    },
    [thickness, height, layerKey]
  )
}
